import { render, staticRenderFns } from "./SystemCodeAdd.vue?vue&type=template&id=996a5948&scoped=true&"
import script from "./SystemCodeAdd.vue?vue&type=script&lang=js&"
export * from "./SystemCodeAdd.vue?vue&type=script&lang=js&"
import style0 from "./SystemCodeAdd.vue?vue&type=style&index=0&id=996a5948&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996a5948",
  null
  
)

export default component.exports